import { COLOR, float, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'T3',
  version: 1,
  label: 'T3 Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 36,
  inputs: [period('timeperiod', 5), float('vfactor', 0.7, 'Volume factor', 0, 1, 0.05)],
  outputs: [line('t3', 'T3', COLOR.blue)],
  talib: { functions: ['T3'], expr: 'T3(close, timeperiod={timeperiod}, vfactor={vfactor})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => 6 * (timeperiod - 1),
}
export default def
